var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUploadPhoto = function SvgUploadPhoto(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#DFE2E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.5C12 15.2239 12.2239 15 12.5 15H17.1033L17.9299 13.2831C18.0132 13.11 18.1883 13 18.3804 13H21.7647C21.9541 13 22.1272 13.107 22.2119 13.2765L23.0733 15H27.5C27.7761 15 28 15.2239 28 15.5V19H26V17H14V23H22V25H12.5C12.2239 25 12 24.7761 12 24.5V15.5Z",
    fill: "#4A5561"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 22C21.1046 22 22 21.1046 22 20C22 18.8954 21.1046 18 20 18C18.8954 18 18 18.8954 18 20C18 21.1046 18.8954 22 20 22Z",
    fill: "#4A5561"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 25V26.5C28 26.7761 27.7761 27 27.5 27H26.5C26.2239 27 26 26.7761 26 26.5V25H24.5C24.2239 25 24 24.7761 24 24.5V23.5C24 23.2239 24.2239 23 24.5 23H26V21.5C26 21.2239 26.2239 21 26.5 21H27.5C27.7761 21 28 21.2239 28 21.5V23H29.5C29.7761 23 30 23.2239 30 23.5V24.5C30 24.7761 29.7761 25 29.5 25H28Z",
    fill: "#4A5561"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUploadPhoto);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "upload_photo.62e005d42d6820bf0e99c0ef79364423.svg";